import React, { useState } from 'react';
import { Plus, Edit, Trash2, PieChart } from 'lucide-react';

const MarkDistribution = () => {
  const [distributions, setDistributions] = useState([]);
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Mark Distribution</h1>
          <p className="text-sm text-gray-500 mt-1">Configure marks distribution for exams</p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          <Plus className="h-4 w-4" />
          Add Distribution
        </button>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
        <p className="text-sm text-blue-700">
          Mark distribution defines how marks are allocated across different components like theory, practical, assignment, etc.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Subject</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Theory Marks</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Practical Marks</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Assignment Marks</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Total Marks</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {distributions.length === 0 ? (
              <tr><td colSpan="6" className="px-6 py-8 text-center text-gray-500">No mark distributions configured</td></tr>
            ) : (
              distributions.map((dist) => (
                <tr key={dist.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{dist.subject}</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-900">{dist.theory}</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-900">{dist.practical}</td>
                  <td className="px-6 py-4 text-center text-sm text-gray-900">{dist.assignment}</td>
                  <td className="px-6 py-4 text-center text-sm font-medium text-blue-600">{dist.total}</td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button className="text-blue-600 hover:text-blue-900"><Edit className="h-4 w-4" /></button>
                      <button className="text-red-600 hover:text-red-900"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarkDistribution;